module.exports = __webpack_public_path__ + "img/logo.e5a985a8.png";